export { TCSMedBenefitCommunicationType } from './generated/TCSMedBenefitCommunicationType.js';